<template>
  <SkeletonRoot
    v-show="loadMoreSleleton"
    v-if="nums"
    v-for="(item, index) in new Array(nums).fill(0)"
    :delay="Math.floor(index / 2)"
    class="init-h5skeleton-item"
  >
    <Skeleton
      aspect-ratio="1"
    />
    <div :style="{ marginTop: '8px', paddingLeft: '4px' }">
      <Skeleton width="80px" />
      <Skeleton height="16px" />
      <Skeleton width="80px" />
      <Skeleton
        :style="{ marginTop: '12px' }"
        height="16px"
      />
      <Skeleton width="80px" />
    </div>
  </SkeletonRoot>
</template>

<script setup>
import { computed, ref, watch } from 'vue'
import { useStore } from 'vuex'
import { SkeletonRoot, Skeleton } from '@/components/Skeleton'

const store = useStore()
const nums = ref(4)

const loadMoreSleleton = computed(() => store.state.loadMoreSleleton)

watch(
  () => store.state.productList.length,
  (newData) => {
    nums.value = newData % 2 === 0 ? 4 : 5
  }
)

watch(loadMoreSleleton, (newData) => {
  if (newData) {
    loadMoreSleleton.value = newData
  }
})

</script>

<style lang="less">
</style>
